import React from "react";
import { cn } from "../../shared/utils";
import { format, isSameDay } from "date-fns";

export function DateValues({ days, containerNavRef }) {
  const formatDate = (date) => {
    return format(date, "EEE");
  };
  return (
    <div
      ref={containerNavRef}
      className="bg-white  border-b-subtle rtl:border-r-default sticky top-[var(--calendar-dates-sticky-offset,0px)] z-[80] flex-none border-b border-r sm:pr-8"
    >
      <div
        className="text-subtle flex text-sm leading-6 "
        data-dayslength={days.length}
      >
        <div className="border-default col-end-1 w-14 ltr:border-l" />
        {days.map((day) => {
          const isToday = isSameDay(day, new Date());
          return (
            <button
              key={day.toString()}
              type="button"
              className={cn(
                "flex flex-1 flex-col items-center pb-3 pt-2",
                isToday && "bg-inverted text-muted rounded-full"
              )}
            >
              {format(day, "EEEEEE")}{" "}
              <span
                className={cn(
                  "text-emphasis mt-1 flex h-8 w-8 items-center justify-center font-semibold",
                  isToday && "bg-inverted text-muted rounded-full"
                )}
              >
                {format(day, "d")}
              </span>
            </button>
          );
        })}
      </div>
      <div className="text-subtle -mr-px hidden  auto-cols-fr text-sm leading-6  ">
        <div className="border-default col-end-1 w-14 ltr:border-l" />
        {days.map((day) => {
          const isToday = isSameDay(day, new Date());
          return (
            <div
              key={day.toString()}
              className={cn(
                "flex flex-1 items-center justify-center py-3 text-xs font-medium uppercase",
                isToday && "font-bold"
              )}
            >
              <span>
                {formatDate(day)}{" "}
                <span
                  className={cn(
                    "items-center justify-center p-1",
                    isToday && "bg-brand-default text-brand rounded-full"
                  )}
                >
                  {format(day, "dd")}
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
